// 模块数据
const state = {
    codeid: "",
    typeName:"",
};

// 模块同步操作
const mutations = {
    updateCodeid(state,val){
        state.codeid = val
    },
    updateTypeName(state,val){
        state.typeName = val
    },
};

// 模块异步操作
const actions = {};

export default {
    state,
    mutations,
    actions,
};